import Bowser from "bowser";

export const clientEnvIsWindows = () => {
  if (!window.navigator.userAgent) return false;
  return Bowser.getParser(window.navigator.userAgent).getOSName(true) === "windows";
};
